import { DossierConfigService } from "@/services/dossier-config-service";
import { i18n } from "@/setup/i18n-setup";
import { PropSelectGroup } from "./prop-select-group";
import { PropSelectItem } from "./prop-select-item";
import { ProductConfig } from "@/models/base/product";

let fields = [
	"ID",
	"Amount",
	"Amount1",
	"Amount2",
	"UnitName",
	"ProductSku",
	"Description",
	"ProductDescriptionOrDescription",
	"UnitPrice",
	"UnitPriceIncl",
	"UnitPriceInclBeforeDiscount",
	"UnitPriceExclBeforeDiscount",
	"Discount",
	"DiscountValue",
	"Vat",
	"NettoPrice",
	"BrutoPrice",
	"Counter",
	"SupplierCode",
	"ManufacturerCode",
	"UnitBuyPrice",
	"LeeggoedTax",
	"LeeggoedUnitTax",
	"TotalPriceExcVatPerUnit",
	"UnitTotal",
	"EcoboniUnitTax",
	"EcoboniTax",
	"AccijnzenUnitTax",
	"AccijnzenTax",
	"FostPlusTax",
	"FostPlustCode",
	"FostPlusTaxPerUnit",
	"UnitPriceInclEuro",
	"NettoPriceEuro",
	"BrutoPriceEuro",
	"UnitPriceEuro",
	"TotalPriceExcVatPerUnitEuro",
	"TrackingNumber",
	"TrackingNumberValidUntil",
	"SizeTableEntryName",
	"ProductWeight",
	"CustomVatInclusiveUnitTax",
	"CustomVatInclusiveTax",
	"CustomVatExclusiveUnitTax",
	"CustomVatExclusiveTax",
	"Barcode"
];

for (let i = 1; i <= ProductConfig.sellPriceCount; i++){
	fields.push(`ProductSellPrice${i}`);
}

for (let i = 1; i <= ProductConfig.sellPriceCount; i++){
	fields.push(`ProductSellPrice${i}WithVat`);
}

export function getSaleRowMapPropSelectGroup():PropSelectGroup{
	let result = new PropSelectGroup("", "", "");
	for (let item of fields){
		result.items.push(new PropSelectItem(i18n.t(`models.map.SaleRow.${item}`), item));
	}

	for (let lang of DossierConfigService.getLanguages().LanguageNames) {
		result.items.push(new PropSelectItem(i18n.t(`models.map.SaleRow.DescriptionLang`, {lang}), `Description_${lang}`));
	}

	let extraFieldsConf = DossierConfigService.getExtraFieldNamesConfigs().ProductNames;
	let extraFields = extraFieldsConf.getActiveFields();
	for (let field of extraFields) {
		result.items.push(new PropSelectItem(extraFieldsConf[field] as string,`ExtraField${field}`));
	}

	extraFieldsConf = DossierConfigService.getExtraFieldNamesConfigs().SaleRowNames;
	extraFields = extraFieldsConf.getActiveFields();
	for (let field of extraFields) {
		result.items.push(new PropSelectItem(extraFieldsConf[field] as string,`RowExtraField${field}`));
	}
	return result;
}
